import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';

export interface CardContentUniDriver extends BaseUniDriver {
  getSize(): Promise<string>;
}
